import React from 'react';
import { FabricCanvasProps } from './fabric-canvas-types';

export const FabricCanvas = ({ canvasRef, addClass = '' }: FabricCanvasProps): React.ReactElement => (
  <canvas className={addClass} ref={canvasRef} />
);
